import { DateTime } from 'luxon';
import { useMemo } from 'react';
import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useUserLanguage } from 'common/hooks/useUserLanguage';
import { useUserLocale } from 'common/hooks/useUserLocale';
import { capitalize } from 'common/utils/stringUtils';

const DayRowRoot = styled(ContentContainer)`
  border-bottom: 1px solid ${color.border};
`;

export const DayRow = ({ variant }: { variant: 'today' | 'yesterday' }) => {
  const userLanguage = useUserLanguage();
  const userLocale = useUserLocale();

  const dateTime = useMemo(
    () => (variant === 'today' ? DateTime.now() : DateTime.now().plus({ days: -1 })),
    [variant],
  );

  return (
    <DayRowRoot verticalPadding="sm">
      <T.Heading variant="headline" level={2}>
        {capitalize(dateTime.toRelativeCalendar({ locale: userLanguage }) || '')},{' '}
        {dateTime.toLocaleString({ month: 'numeric', day: 'numeric' }, { locale: userLocale })}
      </T.Heading>
    </DayRowRoot>
  );
};
